module.exports = __webpack_public_path__ + "static/media/mdb-react.d3e3273c.png";